export var createConnectAudioParam = function createConnectAudioParam(renderInputsOfAudioParam) {
  return function (nativeOfflineAudioContext, audioParam, nativeAudioParam) {
    return renderInputsOfAudioParam(audioParam, nativeOfflineAudioContext, nativeAudioParam);
  };
};